import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { Eye } from "@phosphor-icons/react";

// Shown globally when a super-admin is previewing another club's workspace.
export default function ImpersonationBanner() {
  const { user, refreshMe } = useAuth();
  const { tr } = useLang();
  const [busy, setBusy] = useState(false);

  if (!user || typeof user !== "object" || !user.impersonating) return null;
  const orgName = user.org?.name || "";

  const exit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/superadmin/impersonate", { org_id: null });
      if (data.token) localStorage.setItem("pc_token", data.token);
      await refreshMe();
      window.location.href = "/superadmin";
    } catch (e) {
      setBusy(false);
    }
  };

  return (
    <div data-testid="impersonation-banner" className="sticky top-0 z-[90] bg-amber-500 text-black px-4 py-2 flex items-center justify-center gap-3 text-sm font-semibold">
      <Eye size={18} weight="fill" />
      <span>{tr(`Anteprima club: ${orgName}`, `Previewing club: ${orgName}`)}</span>
      <button onClick={exit} disabled={busy} data-testid="impersonation-exit" className="ml-2 underline underline-offset-2 hover:opacity-80 disabled:opacity-50">
        {busy ? tr("Uscita…", "Exiting…") : tr("Esci dall'anteprima", "Exit preview")}
      </button>
    </div>
  );
}
